// extracted by mini-css-extract-plugin
export default {"logo":"logoAirline_logo__MttaT"};